<div
  class="sb"
  [class.sb--min]="minimized">
  @if (devEnvironment) {
    <div class="sb-dev">
      @if (!minimized) {
        <p class="sb-dev-text">DEV-версия</p>
      }
      @if (minimized) {
        <div class="sb-dev-icon-wrap">
          <i class="pi pi-code sb-dev-icon"></i>
        </div>
      }
    </div>
  }
  <!-- Логотип + явная кнопка сворачивания / разворачивания -->
  <div class="sb-logo">
    <div class="sb-logo-graphic">
      @if (!globalService.globalInfo?.tenantInfo?.avatar) {
        <crm-frm-animated-logo [size]="44"></crm-frm-animated-logo>
      }
      @if (globalService.globalInfo?.tenantInfo?.avatar) {
        <img
          [src]="globalService.globalInfo.tenantInfo.avatar | fileUrl | apiUrl"
          alt="Логотип"
          style="height: 36px; max-width: 110px; object-fit: contain" />
      }
    </div>
    <button
      type="button"
      class="sb-toggle"
      (click)="toggleMinimized.emit(!minimized)"
      [title]="minimized ? 'Развернуть меню' : 'Свернуть меню'"
      [attr.aria-expanded]="!minimized"
      [attr.aria-label]="minimized ? 'Развернуть боковое меню' : 'Свернуть боковое меню'">
      @if (minimized) {
        <i class="pi pi-angle-double-right sb-toggle-ico"></i>
      } @else {
        <i class="pi pi-angle-double-left sb-toggle-ico"></i>
      }
    </button>
  </div>

  <!-- Блок пользователя: профиль ведёт в настройки (информеры и т.д.), как в v1 -->
  <div
    class="sb-user"
    [class.sb-user--collapsed]="minimized">
    <a
      routerLink="/user/settings"
      class="sb-user-profile"
      [class.sb-user-profile--collapsed]="minimized"
      [pTooltip]="minimized ? 'Профиль и настройки' : null"
      tooltipPosition="right"
      [showDelay]="300">
      <crm-user-avatar
        [user]="$any(currentProfile)"
        shape="circle"
        size="large"></crm-user-avatar>
      @if (!minimized) {
        <div class="sb-user-text">
          <div class="sb-user-name">{{ currentProfile?.name }}</div>
          <div class="sb-user-role">{{ currentUser?.job }}</div>
        </div>
      }
    </a>
    @if (!minimized) {
      <div class="sb-user-btns">
        @if (
          [MultiTenancyModeEnum.ENABLED, MultiTenancyModeEnum.LIMITED].includes(
            $any(globalService.globalInfo?.config?.multiTenancyMode)
          )
        ) {
          <button
            type="button"
            class="sb-icon-btn"
            (click)="openTenantDialog()"
            title="Перейти">
            <i class="pi pi-reply"></i>
          </button>
        }
        <button
          type="button"
          class="sb-icon-btn"
          (click)="logout()"
          title="Выход">
          <i class="pi pi-sign-out"></i>
        </button>
      </div>
    }
    @if (minimized) {
      <div class="sb-user-btns sb-user-btns--stack">
        @if (
          [MultiTenancyModeEnum.ENABLED, MultiTenancyModeEnum.LIMITED].includes(
            $any(globalService.globalInfo?.config?.multiTenancyMode)
          )
        ) {
          <button
            type="button"
            class="sb-icon-btn"
            (click)="openTenantDialog()"
            pTooltip="Перейти на другой аккаунт"
            [showDelay]="300"
            tooltipPosition="right">
            <i class="pi pi-reply"></i>
          </button>
        }
        <button
          type="button"
          class="sb-icon-btn"
          (click)="logout()"
          pTooltip="Выход"
          [showDelay]="300"
          tooltipPosition="right">
          <i class="pi pi-sign-out"></i>
        </button>
      </div>
    }
  </div>

  <!-- Пункты модулей -->
  <nav class="sb-nav">
    @for (item of items; track item.routerLink) {
      @if (item.visible !== false) {
        <a
          class="sb-item"
          [routerLink]="item.routerLink"
          routerLinkActive="sb-item--active"
          [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
          [pTooltip]="minimized ? item.label : null"
          tooltipPosition="right">
          <div class="sb-item-icon">
            <i class="{{ item.icon }}"></i>
          </div>
          @if (!minimized) {
            <span class="sb-item-label">{{ item.label }}</span>
          }
          @if (item.badge && !minimized) {
            <span class="sb-item-badge">{{ item.badge }}</span>
          }
        </a>
      }
    }
  </nav>
</div>

<p-dialog
  header="Перейти на другой аккаунт"
  styleClass="xl:w-4 md:w-7 w-11"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="isShowTenantDialog">
  <ng-container *ngIf="!isLoadingTenants; else tenantsLoading">
    <ng-container *ngIf="tenants?.asInternalUser?.length || tenants?.asExternalUser?.length; else notTenantsTemplate">
      <div class="flex align-items-center flex-wrap gap-3">
        <ng-container *ngIf="tenants?.asInternalUser?.length">
          <div
            *ngFor="let tenant of tenants.asInternalUser"
            class="border-1 border-gray-300 cursor-pointer hover:bg-blue-50 border-round-xl p-4"
            (click)="redirectToTenant(tenant, false)">
            <p class="text-lg font-bold text-center">{{ tenant.name }}</p>
          </div>
        </ng-container>

        <ng-container *ngIf="tenants?.asExternalUser?.length">
          <div
            *ngFor="let tenant of tenants.asExternalUser"
            class="border-1 border-gray-300 cursor-pointer hover:bg-blue-50 border-round-xl p-4"
            (click)="redirectToTenant(tenant, true)">
            <p class="text-lg font-bold text-center">{{ tenant.name }} (ЛК)</p>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <div class="mt-5">
      <div class="grid justify-content-center align-items-center flex-wrap">
        <crm-button
          icon="pi pi-plus"
          label="Добавить аккаунт"
          styleClass="p-button-text"
          routerLink="/register"></crm-button>
      </div>
    </div>

    <ng-template #notTenantsTemplate>
      <p class="text-xl font-bold my-3 text-center">Нет других аккаунтов</p>
    </ng-template>
  </ng-container>

  <ng-template #tenantsLoading>
    <crm-spinner></crm-spinner>
  </ng-template>
</p-dialog>
